import { IAction } from './IAction';
import { ActionInfo } from './ActionInfo';

export class Action implements IAction {
    name: string;
    infoStructure: Object;
    info: ActionInfo;

    public static create(actionStructure: Object): IAction {
        return new Action(actionStructure);
    }

    constructor(structure: Object = {}) {
        this.name = structure['name'];
        this.infoStructure = structure['info'];

        this.createInfo();
    }

    createInfo() {
        if (this.infoStructure) {
            this.info = ActionInfo.create('info', this.infoStructure);
        }
    }

    public getData(infoData?: Object): Object {
        let actionData = {};
        //name
        actionData['actionName'] = this.name;

        //info
        if (this.infoStructure) {
            actionData['info'] = infoData;
        }
        return actionData;
    }

    public toString(): string {
        return this.name;
    }
}
